import { Action, Dispatch } from 'redux'
import { initErrorAction, setEmailErrorAction, setPasswordErrorAction } from 'reducks/error/actions'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth, authPersistenceSession, FirebaseUserCredential, staffsRef } from 'firebase/index'
import dexieDb from 'lib/db'
import { StaffType } from 'types/staff'
import { push } from 'connected-react-router'

const signIn = (email: string, password: string, isAutoLogin: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    // エラー文を初期化
    dispatch(initErrorAction())
    dispatch(showLoadingAction())

    // 「次回から自動的にログインする」にチェックが入っていなければ、ブラウザ・タブを閉じたときにログアウト
    if (!isAutoLogin) await auth.setPersistence(authPersistenceSession)

    return auth
      .signInWithEmailAndPassword(email, password)
      .then(async (result: FirebaseUserCredential) => {
        const user = result.user
        if (!user) {
          dispatch(hideLoadingAction())
          throw new Error('ユーザーIDを取得できません')
        }

        await dexieDb.auth.put({
          uid: user.uid,
          is_admin: false,
          is_signed_in: false,
          role: 0,
          brand_id: undefined,
          shop_id: undefined,
          store_id: undefined,
        })

        const staff = await staffsRef
          .where('uid', '==', user.uid)
          .get()
          .then((snapshots) => {
            if (snapshots.docs.length > 1) return undefined
            return snapshots.docs[0].data() as StaffType
          })

        if (!staff) {
          dispatch(hideLoadingAction())
          throw new Error('スタッフが存在しません')
        }

        if (staff.is_admin) {
          dispatch(push('/admin/shops'))
        } else if (staff.roles.length === 0) {
          await auth.signOut()
          dispatch(setEmailErrorAction('店舗にアクセスする権限がありません'))
        } else {
          dispatch(push('/'))
        }
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        // Firebase Authのエラーコードに応じてエラー文を表示
        switch (error.code) {
          case 'auth/wrong-password':
            dispatch(setPasswordErrorAction('パスワードが正しくありません'))
            break
          case 'auth/user-not-found':
            dispatch(setEmailErrorAction('メールアドレスが正しくありません'))
            break
          case 'auth/too-many-requests':
            dispatch(
              setPasswordErrorAction(
                '複数回ログインに失敗しているため、ログインを一時的に制限しています。しばらく時間を置いてから再度ログインしていただくか、「パスワードをお忘れの方はこちら」からパスワードをリセットしてください。'
              )
            )
            break
          default:
            console.error(error)
            dispatch(initErrorAction())
            break
        }
        dispatch(hideLoadingAction())
      })
  }
}

export default signIn
